import type { ProductData } from '@elfsight/widget-stripe-payment';
import { isPaymentCurrency } from '@elfsight/widget-stripe-payment';
import { isValidPaymentAmount } from '@elfsight/widget-stripe-payment/src/widget';
import type { AppointmentBookingService } from '../../types';

export function getProductData(
  serviceData?: AppointmentBookingService
): ProductData | undefined {
  if (!serviceData) {
    return;
  }

  const { name: serviceName, price: servicePrice } = serviceData;

  const paymentCurrencyValue = servicePrice.currency.trim().toUpperCase();

  if (!isPaymentCurrency(paymentCurrencyValue)) {
    console.warn('Unsupported payment currency:', paymentCurrencyValue);

    return;
  }

  const [isValid, error] = isValidPaymentAmount({
    amount: servicePrice.price,
    currency: paymentCurrencyValue
  });

  if (!isValid) {
    console.warn(`Invalid payment amount ${error}:`, servicePrice.price);

    return;
  }

  return {
    name: serviceName,
    amount: servicePrice.price,
    currency: paymentCurrencyValue,
    quantity: 1
  };
}
